<template>
  <div class="page white_bg">

    <div style="height: 46px;">
      <!-- set height if pageHeader is fixed position -->
      <header class="pageHeader white_bg" style="line-height: 30px;">
        <div class="borderLayout paddingH16 paddingV8">
          <div class="middleRegion">
            <div class="westRegion" style="width: 60px">
              <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
            </div>
            <div class="centerRegion alignCenter font18r primaryTextColor bold" style="height: 30px; overflow: hidden">
              {{ title }}
            </div>
            <div class="eastRegion font14r alignRight" style="width: 60px">
<!--              <router-link :to="{name : 'search'}">-->
<!--                <i class="icon searchIcon" style="margin-top: 3px;"></i>-->
<!--              </router-link>-->
            </div>
          </div>
        </div>
      </header>
    </div>
    <div class="body" style="">
      <div class="generalPagePaddingH" style="margin-top: 12px;">
          <bannerModule4 :itemCount="99" version="4" categoryKey="TEACHER_LIST_PAGE" />
      </div>
      <!-- 老师列表 -->
      <div class="dataList" style="padding: 24px 16px 0 16px;">
        <div class="dataItemRow" v-for="dataItem in dataList" :key="dataItem.id" @click="viewItem(dataItem)">
          <div>
            <img style="width: 64px;height: 64px;border-radius: 50%;" :src="dataItem.userHead" v-if="dataItem.userHead" />
          </div>
          <div class="teacherInfo">
            <div class="teacherName">
              <span>{{ dataItem.teacherName }}</span>
              <span class="ipName">/ {{ dataItem.ipName }}</span>
            </div>
            <div class="teacherTags">
              <span class="tag" v-for="(tag, index) in dataItem.tagsList " :key="index"
                :class="index % 2 == 0 ? 'borderColorYellow' : 'borderColorRed' ">
                {{ tag }}
              </span>
            </div>
            <div class="teacherSignature">{{ dataItem.signature }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import bannerModule4 from '../ad/bannerModule4';

// config
import appConfig from '@/appConfig';
import consoleApi from '../platformApi/consoleApi';

// util
import appHelper from '@/util/appHelper';

const config = {
  name: 'topicVodCoursePage',
  title: '师讯讲师',
  description : appConfig.name + ' - ' + appConfig.desc,
  apiConfig: {
    list: {
      url: '/portal/teacher/v2',
      dataPath: 'data.records',
      totalPath: 'data.total',
      totalPagePath: 'data.pages',
      dataColumnMapping: {
        // userName : 'name''
      }
    }
  },
  demoTitleList: [
    '园长“苦恼”，幼儿园之间到底在竞争什么',
    '如何使运营的微信公众号活跃起来？',
    '做好这几点，让园区摆脱对名师的依赖'
  ]
};

export default {
  name: config.name,
  extends: shixunPagePart,
  components: { bannerModule4 },
  data () {
    return {
      title: config.title,
      description: config.description,
      apiConfig: config.apiConfig,
      enableDataList: true,
      autoLoadDataList: appConfig.mode != 'demo',
    }
  },
  methods: {
    viewItem (dataItem) {
      appHelper.goToPage('lecturerDetailPage', {
        id: dataItem.id
      });
    },
    randomHexColor () { //随机生成十六进制颜色
      var hex = Math.floor(Math.random() * 16777216).toString(16); //生成ffffff以内16进制数
      while (hex.length < 6) { //while循环判断hex位数，少于6位前面加0凑够6位
        hex = '0' + hex;
      }
      return '#' + hex; //返回‘#'开头16进制颜色
    }
  },
}
</script>

<style lang="scss" scoped>
.lightGrey {
  color: hsla(219, 16%, 60%, 1);
}
.grey {
  color: hsla(219, 9%, 39%, 1);
}
.searchIcon {
  width: 18px;
  height: 19px;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAADVklEQVRYhcWYT4jVVRTHb00DNgYiuRUXuhAdH9zz+d6hgSf8RKQhGC3ih2U7CSIIhEJdBEK0qFaKKBptBLFoIWYgLRKhiGgSUjcTiFhBQfindPUGG2dczHvTnTu/9+b9Zt6fA2fx3r3nnM895/7uP+dKSJ7nA977ncAHkr6RdBuoAbPAbP33FUlHzewVYLCM/1ICrAM+BO40ANpRM5uS9CmwuZMwQ8CRMiAt9DNg3YqAJA0Dv7YI8kDSz5IuRnoV+LOFzUNJu5YFZGZjZjZV5BQ4I2lkCftNko4CfzSBe9s593SZDO0pcDIl6USWZavKDtB7f7g+mNTngbYcmFklzZCZ/SbJl4WJpVqtrgV+KfgQ9rY0BNYAtxPDyeVkp0WMr9Kv08w2NTWQ9EmaoU4CRXF+TOJczrLsmUUdQwjrC+bQikrWTEZHR59N1ztJe4roTyRQx7oB1BBgHzATxbuxoEOWZauSyf2wG2UrALuWZOv/ykh6NcnSmW4D1eO+k0AdiomPJ40tF8ZOCjAdxf4hJv4uLl2vgOpQ16PYNefcU42G36MsXe0x1KW4SiGE9Y2GeD5d6THUuTi+937DIihJX/cTysxwzjlnZv/2sXyfNytffGb6q5dQki7HUPPrY0I7MzIy8nyvoIC/o9i34oYDSQrf6wWQmW1PPrKT843e+y3JZO/JvJJ0MYF6eUEH4Ke4hJJe6iYQc7ej/+KFc9HxpWD/u9lNKEnfJtU5uKhTnucD9ZtIvGZ80SWgQ8mxpQasKexsZi8k2ZqR9H4ngUIIe4FHSZZeX2oUBxOwaeBUJ4CAN1Mg4Fye5wNLGQ5KOp0YzgITK1m/zOy8pOnE57VKpbK63RENAV8WgNWAC+3CjY+PD5nZSeBBga9Z4D5l3hiAQeDjJs4eAzfM7Kyk/ZKGG+q9fw04Bkyw8ADXTO9577e0Deacc2b2YrIVrERrkvYD/yT/3w0hbC0FVqlUVgPvxqeJZehH1Wp1rXPzO8j9FEzScCkw5+ZuPSGEcUnniR7KWuglM3sjy7LnUl8hhK3AvaT/HWBbabCG5Hk+AGwMIYxJ2i3pLe/97hDCmJlVXBsvKvWnprspWN2+fwJsKwD7vq9Qzs299LDwGj/Zbybn3DzYBDAJ7HgCwHW6Z9xb1m4AAAAASUVORK5CYII=');
}
.dataItemRow {
  border-bottom: 1px solid #f6f6f6;
  padding: 0 0 17px 0;
  margin-bottom: 16px;
  display: flex;
  .teacherInfo {
    margin-left: 12px;
    width: calc(100% - 60px);
    .teacherName {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      opacity: 1;
      .ipName {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #8994a9;
        opacity: 1;
        margin-left: 4px;
      }
    }
    .teacherTags {
      .tag {
        width: fit-content;
        opacity: 1;
        height: 14px;
        border-radius: 4px;
        padding: 0 6px;
        font-size: 10px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        opacity: 1;
        margin: 0 4px;
        display: inline-block;
      }
    }
    .teacherSignature {
      margin-top: 16px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #5b616c;
      opacity: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: calc(100% - 34px);
    }
  }
}
.borderColorYellow {
  border: 1px solid #ffbc3b;
  color: #ffa724;
}
.borderColorRed {
  border: 1px solid #ff4d48;
  color: #ff4d48;
}
</style>
